import http from './http.service';

class MakesModelsService {
    constructor() {
        if (MakesModelsService.instance) {
            return MakesModelsService.instance;
        }

        MakesModelsService.instance = this;
    }

    makesModels() {
        return http.get('/makes-models').then(res => res.data);
    }
    storeMake(data) {
        return http.post('/makes-models/store-make', data).then(res => res.data);
    }
    updateMake(makeId, data) {
        return http.put(`/makes-models/${makeId}/update-make`, data).then(res => res.data);
    }
    storeModel(data) {
        return http.post('/makes-models/store-model', data).then(res => res.data);
    }
    updateModel(modelId, data) {
        return http.put(`/makes-models/${modelId}/update-model`, data).then(res => res.data);
    }
    // show(promocodeId) {
    //     return http.get(`/makes-models/${promocodeId}/show`).then(res => res.data);
    // }
    // update(promocodeId, data) {
    //     return http.put(`/makes-models/${promocodeId}/update`, data).then(res => res.data);
    // }
    destroyModel(modelId) {
        return http.delete(`/makes-models/${modelId}/destroy-model`).then(res => res.data);
    }
}

export default new MakesModelsService();
